import { makeStyles,useTheme } from '@material-ui/core/styles';

export const useStyles = makeStyles(theme => ({
  container: {
    minWidth: '220px',
    minHeight: '100%',
    boxShadow: 'inset -1px 0px 0px #e2ebf6',
    [theme.breakpoints.down('sm')]: {
      display: 'none', 
    },
  },
  indicator: {
    backgroundColor: '#008db0'
  },
  title: {
    padding: '12px 30px'
  },
  tabLabel: {
    display: 'flex',
    alignItems: 'center',
    width: '100%',
    textTransform: 'initial'
  },
  errorIcon: {
    fontSize: '18px',
    color: 'red',
    marginRight: '10px'
  },
  doneIcon: {
    color: '#27ABD4',
    fontSize: '18px',
    marginRight: '12px'
  },
  customLabel: {
    display: 'flex',
    alignItems: 'center'
  },
  tabIsFilled: {
    color: '#000000'
  },
  selectedLabel: {
    fontWeight: '500',
    color: '#000000'
  },
  tabIsAvailable: {
    cursor: 'pointer !important',
    color: '#000000 !important'
  }
}));

export const tabStyles = makeStyles({
  wrapper: {
    alignItems: 'flex-start'
  },
  root: {
    fontSize: '13px',
    lineHeight: '18px',
    fontWeight: 'normal',
    color: '#99ADBD',
    padding: '9px 0 9px 30px',
    margin: '0 0 6px',
    textAlign: 'left',
    minHeight: '36px',
    cursor: 'not-allowed'
  },
  selected: {
    backgroundColor: '#e2f5f8',
    fontWeight: '500',
    color: '#000000',
    cursor: 'pointer'
  }
});
